import * as Actions from '../../actions/register/index';

const initialState = null;

const register = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.SET_REGISTER:
        {
            return action.payload;
        }

        case Actions.REMOVE_REGISTER:
        {
            return initialState;
        }
        
        default:
        {
            return state;
        }
    }
}

export default register;